import { getUser } from "../api/AuthProvider"
import { Resource } from "../api/Resource";
import { StorageItem } from "./constants";

export const acquireResourceId = async (): Promise<string> => {
  let resouceId = localStorage.getItem(StorageItem.ResourceId);
  if (resouceId) return resouceId;


  const user = await getUser();
  const resources = await Resource.getAll(`$filter=EmailAddress eq '${user.email}' or WindowsAccount eq '${user.email}'`);
  if (resources.length < 1) {
    console.log(`Resource for user ${user.email} not found!`);
    return undefined;
  }

  resouceId = resources[0].Id;
  localStorage.setItem(StorageItem.ResourceId, resouceId)
  return resouceId;
}